import { Box } from '@mantine/core';
import { useId } from 'react';

import type { IconPropsType } from './types';

export const FlagEsIcon = ({ size = 24, sx, ...props }: IconPropsType) => {
  const id = useId();

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path d="M24 0H0V6H24V0Z" fill="#AD1519" />
        <path d="M24 18H0V24H24V18Z" fill="#AD1519" />
        <path d="M24 6H0V18H24V6Z" fill="#FABD00" />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </Box>
  );
};
